import type { ObjectDirective } from 'vue';

import { isTestingEnv } from '@modules/core/services/env-config/utils/envConfig';

export function vDataQaAutoId({
  elemAttrName,
}: {
  elemAttrName: string;
}): ObjectDirective<Element> {
  return {
  // Directive has a mounted and updated lifecycle hook
    mounted(el, binding): void {
      if (isTestingEnv() && binding.value && el instanceof Element) {
        el.setAttribute(elemAttrName, `${binding.value}`);
      } else {
        el.removeAttribute(elemAttrName);
      }
    },
    updated(el, binding): void {
      if (el instanceof Element) {
        if (isTestingEnv() && binding.value) {
          el.setAttribute(elemAttrName, `${binding.value}`);
        } else {
          el.removeAttribute(elemAttrName);
        }
      }
    },
  };
}
